import type { Cell } from '@forecastify/ui';

/**
 * 21 Oct 2026 · **a person in a list cell: the face and the name, always together.** Card view
 * draws this cell on its own line under the title, and the lists disagreed — some passed a face,
 * some only a name — so one card showed a person and the next a bare word. This is the one shape.
 *
 * ⚠️ `seed` is the person's normalised email (`wireAvatarSeed`), so the generated face matches the
 * one they have everywhere else; `src` is a resolved picture, when the screen has one.
 */
export function personCell(
  name: string | null,
  face: { readonly seed?: string | null; readonly src?: string } = {},
): Cell {
  /* ⚠️ An em-dash for nobody — `state-rules.md` §5's absent value. */
  if (name === null || name.trim() === '') return { text: '–', muted: true };
  return {
    text: name,
    avatar: {
      initials: initialsOf(name),
      ...(face.seed === null || face.seed === undefined ? {} : { seed: face.seed }),
      title: name,
      ...(face.src === undefined ? {} : { src: face.src }),
    },
  };
}

function initialsOf(name: string): string {
  return name
    .split(/\s+/u)
    .filter((part) => part !== '')
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}
